// extracted by mini-css-extract-plugin
export default {"root":"Step_root__-lmAZ","headings":"Step_headings__NOTi2","titleWrapper":"Step_titleWrapper__e3oXg"};